import * as React from 'react';
import { SVGProps } from 'react';

const IconMapFilledSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 2.359 1 4.397V15l3-2.038V2.359ZM6 12.471l4 1.36V3.528l-4-1.36v10.302ZM15 1v10.603l-3 2.038V3.038L15 1Z" />
  </svg>
);
export default IconMapFilledSizeS;
